import { LogError } from './errorLogger';

export const MERCH_VIEWED_SAVED_SEARCHES = 'merchViewedSavedSearches';

export type ViewedSavedSearchItem = {
  cvnaid: string;
  expiration: number;
};

const FIVE_MINUTES = 5 * 60 * 1000;

export const setSearchViewed = (cvnaid: string, logError?: LogError): void => {
  const storageItem = sessionStorage.getItem(MERCH_VIEWED_SAVED_SEARCHES) || '';
  const viewedSearches: ViewedSavedSearchItem[] = (() => {
    try {
      return storageItem ? JSON.parse(storageItem) : [];
    } catch {
      return [];
    }
  })();

  const item: ViewedSavedSearchItem = {
    expiration: new Date().getTime() + FIVE_MINUTES,
    cvnaid
  };

  try {
    sessionStorage.setItem(
      MERCH_VIEWED_SAVED_SEARCHES,
      JSON.stringify([...viewedSearches, item])
    );
  } catch (e) {
    // TODO: Update logError to required prop and refactor setSearchViewed
    if (logError) {
      logError?.(e, {
        location: 'setSearchViewed',
        operation: 'sessionStorage'
      });
    } else {
      console.error(`[SearchBar] Error in setSearchViewed:`, e, {
        location: 'setSearchViewed',
        operation: 'sessionStorage'
      });
    }
  }
};

export const resetNotificationForViewedSearches = <
  T extends { cvnaId: string; totalNewVehicles?: number }
>(
  searches: T[]
): T[] => {
  const storageItems =
    sessionStorage.getItem(MERCH_VIEWED_SAVED_SEARCHES) || '';
  const parsedSearches: ViewedSavedSearchItem[] = (() => {
    try {
      return storageItems ? JSON.parse(storageItems) : [];
    } catch {
      return [];
    }
  })();

  if (!parsedSearches.length) return searches;

  const viewedSearches = parsedSearches.filter(
    storageItem => storageItem.expiration > new Date().getTime()
  );

  return searches.map(search => ({
    ...search,
    totalNewVehicles: viewedSearches.find(
      storageItem => storageItem.cvnaid === search.cvnaId
    )
      ? 0
      : search.totalNewVehicles
  }));
};
